module.exports = __webpack_public_path__ + "static/media/03.42f3ee96.jpg";